import { render } from "./MontaInput.vue?vue&type=template&id=c7285e86"
import script from "./MontaInput.vue?vue&type=script&lang=js"
export * from "./MontaInput.vue?vue&type=script&lang=js"

import "./MontaInput.vue?vue&type=style&index=0&id=c7285e86&lang=scss"

import exportComponent from "/home/runner/work/alperlab/alperlab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__